import Vue from 'vue';
import VueRouter from 'vue-router';
// 引入默认访问组件
import Layout from '@/views/Layout.vue';
import Login from '@/views/Login.vue';

// 引入本地存储
import session from '@/utils/session';

// 使用路由
Vue.use(VueRouter);

// 解决面包屑导航重复路由警告
const routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return routerPush.call(this, location).catch((error) => error);
};

// 基础路由配置
let routes = [
    // 登录
    {
        path: '/login',
        component: Login
    },
    // 后端首页
    {
        path: '/',
        component: Layout,
        redirect: '/home',
        children: [
            {
                path: '/home',
                meta: { title: "首页" },
                component: () => import('@/views/Home.vue')
            },
            {
                path: '/doctorDataAnalysis',
                meta: { title: "医生数据" },
                component: () => import('@/views/DoctorManage/doctorDataAnalysis/doctorDataAnalysis.vue')
            },
            // 医生拜访ltc
            {
                path: '/doctorVisitLTC/goalConfig',
                meta: { title: "目标配置" },
                component: () => import('@/views/DoctorVisitLTC/views/goalConfig/goalConfig.vue')
            },
            {
                path: '/doctorVisitLTC/workbench',
                meta: { title: "工作台" },
                component: () => import('@/views/DoctorVisitLTC/views/workbench/workbench.vue')
            },
            {
                path: '/doctorVisitLTC/signedList',
                meta: { title: "已签约" },
                component: () => import('@/views/DoctorVisitLTC/views/signedList/signedList.vue')
            }
        ]
    },
    // 404页面
    {
        path: '/404',
        component: Layout,
        children: [{
            path: '/404',
            component: () =>
                import('@/views/404.vue')
        }]
    },
    // 开发票
    {
        path: '/issueInvoice',
        component: () => import('@/views/IssueInvoice.vue')
    },
    // 工具
    {
        path: '/utils',
        component: () => import('@/views/utils/index.vue')
    },
    {
        path: '/utils/smsInquiry',
        component: () => import('@/views/utils/smsInquiry.vue')
    }
];

// 所有路由
const asyncRoutes = [
    // 账号中心
    {
        path: '/account',
        component: Layout,
        children: [{
            path: '/account/passwordmodify',
            component: () =>
                import('@/views/Account/PasswordModify.vue')
        },
        {
            path: '/account/personal',
            component: () =>
                import('@/views/Account/Personal.vue')
        }
        ]
    },
    // 挂号管理
    {
        path: '/registration',
        component: Layout,
        children: [{
            path: '/registration/register',
            component: () =>
                import('@/views/Registration/Register.vue')
        },
        {
            path: '/registration/takenum',
            component: () =>
                import('@/views/Registration/TakeNum.vue')
        },
        {
            path: '/registration/sign',
            component: () =>
                import('@/views/Registration/Sign.vue')
        },
        {
            path: '/registration/signrecord',
            component: () =>
                import('@/views/Registration/SignRecord.vue')
        },
        {
            path: '/registration/physioRegister',
            component: () =>
                import('@/views/Registration/physioRegister.vue')
        },
        ]
    },
    // 医生工作站Request
    {
        path: "/doctorworkstation",
        component: Layout,
        children: [
            {
                path: '/doctorworkstation/newDiagnosis',
                component: () =>
                    import('@/views/DoctorWorkstation/newDiagnosis/index.vue')
            },
            {
                path: '/doctorworkstation/physioexecutelist',
                component: () =>
                    import('@/views/DoctorWorkstation/PhysioExecuteList/index.vue')
            }
        ]
    },
    // 划价管理
    {
        path: "/pricing",
        component: Layout,
        children: [{
            path: '/pricing/pricingdetails',
            component: () =>
                import('@/views/Pricing/PricingDetails.vue')
        },
        {
            path: '/pricing/refundList',
            component: () =>
                import('@/views/Pricing/refundList/refundList.vue')
        },
        {
            path: '/pricing/orderdetails',
            component: () =>
                import('@/views/Pricing/OrderDetails.vue')
        },
        {
            path: '/pricing/orderlist',
            component: () =>
                import('@/views/Pricing/OrderList.vue')
        },
        {
            path: '/pricing/onlinetaking',
            component: () =>
                import('@/views/Pricing/OnlineTaking/index.vue')
        }
        ]
    },
    // 配方管理
    {
        path: '/formula',
        component: Layout,
        children: [{
            path: '/formula/formulalist',
            component: () =>
                import('@/views/Formula/FormulaList.vue')
        },
        {
            path: '/formula/formuladetails',
            component: () =>
                import('@/views/Formula/FormulaDetails.vue')
        },
        {
            path: '/formula/orderlist',
            component: () =>
                import('@/views/Formula/OrderList.vue')
        },
        {
            path: '/formula/orderdetails',
            component: () =>
                import('@/views/Formula/OrderDetails.vue')
        },
        ]
    },
    // 患者档案
    {
        path: '/patient',
        component: Layout,
        children: [{
            path: '/patient/patientdetails',
            component: () =>
                import('@/views/Patient/PatientDetails.vue')
        },
        {
            path: '/patient/memberlist',
            component: () =>
                import('@/views/Patient/MemberList/index.vue')
        },
        // {
        //     path: '/doctorworkstation/physioexecutedetails',
        //     component: () =>
        //         import('@/views/DoctorWorkstation/PhysioExecuteDetails.vue')
        // },
        {
            path: '/patient/patientlist',
            component: () =>
                import('@/views/Patient/PatientList.vue')
        },
        {
            path: '/patient/labelmanage',
            component: () =>
                import('@/views/Patient/LabelManage/index.vue')
        },
        {
            path: '/patientfollowup/followuplist',
            component: () =>
                import('@/views/PatientFollowUp/FollowUpList.vue')
        },
        {
            path: '/patientfollowup/followupdetails',
            component: () =>
                import('@/views/PatientFollowUp/FollowUpDetails.vue')
        },
        {
            path: '/patientfollowup/questionnairelist',
            component: () =>
                import('@/views/PatientFollowUp/Questionnaire/index.vue')
        },
        {
            path: '/patientfollowup/questionnairedetails',
            component: () =>
                import('@/views/PatientFollowUp/Questionnaire/QuestionnaireDetails.vue')
        },
                {
            path: '/patient/intendedPatient/list',
            component: () => import('@/views/Patient/intendedPatient/list.vue'),
            meta: {
                title: '意向患者管理'
            }
        },
        {
            path: '/patient/intendedPatient/edit/:id?',
            component: () => import('@/views/Patient/intendedPatient/edit.vue'),
            meta: {
                title: '意向患者信息编辑'
            }
        },
        {
            path: '/patient/intendedPatient/detail/:id',
            component: () => import('@/views/Patient/intendedPatient/detail.vue'),
            meta: {
                title: '意向患者信息详情'
            }
        }
        ]
    },

    // 患者随访
    // {
    //     path: '/patientfollowup',
    //     component: Layout,
    //     children: [
    //         {
    //             path: '/patientfollowup/followuplist',
    //             component: () =>
    //                 import('@/views/PatientFollowUp/FollowUpList.vue')
    //         },
    //         {
    //             path: '/patientfollowup/followupdetails',
    //             component: () =>
    //                 import('@/views/PatientFollowUp/FollowUpDetails.vue')
    //         },
    //         {
    //             path: '/patientfollowup/questionnairelist',
    //             component: () =>
    //                 import('@/views/PatientFollowUp/Questionnaire/index.vue')
    //         },
    //         {
    //             path: '/patientfollowup/questionnairedetails',
    //             component: () =>
    //                 import('@/views/PatientFollowUp/Questionnaire/QuestionnaireDetails.vue')
    //         },
    //     ]
    // },
    // 医生管理
    {
        path: '/doctormanage',
        component: Layout,
        children: [{
            path: '/doctormanage/doctorlist',
            component: () =>
                import('@/views/DoctorManage/DoctorList.vue')
        },
        {
            path: '/doctormanage/scheduling',
            component: () =>
                import('@/views/DoctorManage/Scheduling/index.vue')
        },
        {
            path: '/doctormanage/scheduleRules/:id',
            component: () => import('@/views/DoctorManage/Scheduling/ScheduleRules.vue')
        },
        {
            path: '/doctormanage/titlemanage',
            component: () =>
                import('@/views/DoctorManage/TitleManage.vue')
        },
        {
            path: '/doctormanage/labelmanage',
            component: () =>
                import('@/views/DoctorManage/LabelManage.vue')
        },
        {
            path: '/doctormanage/webchatdoctor',
            component: () =>
                import('@/views/DoctorManage/WebChatDoctor.vue')
        },
        {
            path: '/doctormanage/evaluate',
            component: () =>
                import('@/views/DoctorManage/Evaluate.vue')
        },
        {
            path: '/doctormanage/studio',
            component: () =>
                import('@/views/DoctorManage/studio.vue')
        }
        ]
    },
    // 医用模板管理
    {
        path: '/medicaltemplate',
        component: Layout,
        children: [{
            path: '/medicaltemplate/prescriptiontemplate',
            component: () =>
                import('@/views/MedicalTemplate/PrescriptionTemplate.vue')
        },
        {
            path: '/medicaltemplate/consultationquestionnairelist',
            component: () =>
                import('@/views/MedicalTemplate/ConsultationQuestionnaire.vue')
        },
        {
            path: '/medicaltemplate/consultationquestionnairedetails',
            component: () =>
                import('@/views/MedicalTemplate/ConsultationQuestionnaireDetails.vue')
        },
        {
            path: '/medicaltemplate/medlinker',
            component: () =>
                import('@/views/MedicalTemplate/medlinker/medlinker.vue')
        },
        {
            path: '/medicaltemplate/medlinkerManager',
            component: () =>
                import('@/views/MedicalTemplate/medlinker/medlinkerManager.vue')
        },
        ]
    },
    // 医保管理
    {
        path: '/medicalInsurance',
        component: Layout,
        children: [
            {
                path: '/medicalInsurance/account',
                component: () =>
                    import('@/views/MedicalInsurance/Account/index.vue')
            }
        ]
    },
    // 管理
    {
        path: '/power',
        component: Layout,
        children: [{
            path: '/power/menu',
            component: () =>
                import('@/views/Power/Menu.vue')
        },
        {
            path: '/power/role',
            component: () =>
                import('@/views/Power/Role.vue')
        },
        {
            path: '/power/user',
            component: () =>
                import('@/views/Power/User.vue')
        },
        {
            path: '/power/operator',
            component: () =>
                import('@/views/Power/Operator.vue')
        },
        {
            path: '/power/physiotherapist',
            component: () =>
                import('@/views/Power/Physiotherapist.vue')
        },
        {
            path: '/backstage/storemanage',
            component: () =>
                import('@/views/Backstage/StoreManage/index.vue')
        },
        {
            path: '/backstage/charge',
            component: () =>
                import('@/views/Backstage/Charge/index.vue')
        },
        {
            path: '/backstage/medicaldata',
            component: () =>
                import('@/views/Backstage/MedicalData/index.vue')
        },
        {
            path: '/backstage/physioPowerList',
            component: () =>
                import('@/views/Backstage/PhysioManage/physioPowerList.vue')
        },
        {
            path: '/backstage/physioPowerEdit/:id',
            component: () =>
                import('@/views/Backstage/PhysioManage/physioPowerEdit.vue')
        },
        {
            path: '/backstage/region',
            component: () =>
                import('@/views/Backstage/Region.vue')
        },
        {
            path: '/backstage/wechat',
            component: () =>
                import('@/views/Backstage/WeChat/index.vue')
        },
        {
            path: '/power/printer',
            component: () =>
                import('@/views/Power/Printer/index.vue')
        },
        {
            path: '/backstage/mobile',
            component: () =>
              import('@/views/Backstage/Mobile/index.vue')
        },
        {
            path: '/backstage/mobile/dynamic_add',
            component: () =>
              import('@/views/Backstage/Mobile/dynamic-add.vue')
        },
        // 活动管理-列表
        {
            path: '/backstage/campaignList',
            component: () => import('@/views/Backstage/campaignManagement/campaignList.vue')
        },
        {
            path: '/backstage/intermediaryPlatformOrder',
            component: () =>
              import('@/views/Backstage/intermediaryPlatformOrder/intermediaryPlatformOrder.vue')
        }
        ]
    },
    // 报表管理
    {
        path: "/statement",
        component: Layout,
        children: [{
            path: '/statement/dept',
            component: () =>
                import('@/views/Statement/Dept/index.vue')
        },
        {
            path: '/statement/drug',
            component: () =>
                import('@/views/Statement/Drug/index.vue')
        },
        {
            path: '/statement/staffcharge',
            component: () =>
                import('@/views/Statement/StaffCharge/index.vue')
        },
        {
            path: '/statement/staffformula',
            component: () =>
                import('@/views/Statement/StaffFormula/index.vue')
        },
        {
            path: '/statement/followup',
            component: () =>
                import('@/views/Statement/FollowUp/index.vue')
        },
        {
            path: '/statement/takeorders',
            component: () =>
                import('@/views/Statement/TakeOrders.vue')
        },
        {
            path: '/statement/registration',
            component: () =>
                import('@/views/Statement/Registration.vue')
        },
        {
            path: '/statement/allStatement',
            component: () =>
                import('@/views/Statement/allStatement/index.vue')
        }, 
        {
            path: '/statement/reportDetails',
            component: () =>
                import('@/views/Statement/allStatement/reportDetails.vue')
        }, {
            path: '/statement/revenue',
            component: () =>
                import('@/views/Statement/revenue/index.vue')
            }, {
            path: '/statement/performance',
                component: () =>
                    import('@/views/Statement/performance/index.vue')
            },
            {
                path: '/statement/warehousing',
                    component: () =>
                        import('@/views/Statement/warehousing/index.vue')
            },
            {
                path: '/statement/outbound',
                    component: () =>
                        import('@/views/Statement/outbound/index.vue')
            },
            {
                path: '/statement/inventory',
                    component: () =>
                        import('@/views/Statement/inventory/index.vue')
            },
            {
                path: '/statement/warehouseDetail',
                    component: () =>
                        import('@/views/Statement/warehouseDetail/index.vue')
            },
            {
                path: '/statement/supplierInfo',
                    component: () =>
                        import('@/views/Statement/supplierInfo/index.vue')
            },
        {
            path: '/statement/salesReport',
            component: () =>
                import('@/views/Statement/salesReport/index.vue')
        },
        {
            path: '/statement/operationAnalysis',
            component: () =>
                import('@/views/Statement/operationAnalysis/index.vue')
        },
        {
            path: '/statement/recipeBatchPrint',
            component: () =>
                import('@/views/Statement/recipeBatchPrint/index.vue')
        },
        {
            path: '/statement/stockSummary',
            component: () =>
                import('@/views/Statement/stockSummary/index.vue')
        },
        ]
    },
    // 后台管理
    {
        path: '/backstage',
        component: Layout,
        children: [
            {
                path: '/backstage/storemanage',
                component: () =>
                    import('@/views/Backstage/StoreManage/index.vue')
            },
            {
                path: '/backstage/charge',
                component: () =>
                    import('@/views/Backstage/Charge/index.vue')
            },
            {
                path: '/backstage/medicaldata',
                component: () =>
                    import('@/views/Backstage/MedicalData/index.vue')
            },
            {
                path: '/backstage/region',
                component: () =>
                    import('@/views/Backstage/Region.vue')
            },
            {
                path: '/backstage/wechat',
                component: () =>
                    import('@/views/Backstage/WeChat/index.vue')
            },

        ]
    }
];

// 路由history模式
const router = new VueRouter({
    mode: 'history',
    base: window.__POWERED_BY_QIANKUN__ ? '/system/his_system' : process.env.BASE_URL,
    routes
});

// 创建动态的路由
export function createRoutes() {
    let menuList = session.get('menuList');
    if (!menuList) return;
    else calcRoutes(menuList); // 过滤可访问路由
    router.addRoutes(routes); // 添加动态路由
}

createRoutes(); // 初始化调用

// 生成动态路由
function calcRoutes(menuList) {
    let router = {};
    asyncRoutes.forEach(item => {
        menuList.forEach(items => {
            if (item.path == items.path) {
                router = { path: item.path, meta: items.meta, component: item.component, redirect: item.redirect, children: [] };
                item.children && item.children.forEach(kid => {
                    items.children && items.children.forEach(kids => {
                        if (kid.path == kids.path) {
                            kid.meta = kids.meta;
                            router.children.push(kid);
                        }
                    });
                });
                routes.push(router);
            }
        });
    });

};

// 全局路由守卫
router.beforeEach((to, from, next) => {
    if (to.query.version) {
        const newQuery = { ...to.query }
        delete newQuery.version
        router.replace({
            parh: to.path,
            query: newQuery
        })
    }
    if (session.get('t_k')) {
        if (to.matched.length === 0) next('/404');
        else next();
    } else {
        const ignoreList = ['/login', '/issueInvoice']
        if (ignoreList.includes(to.path)) {
            next()
        } else {
            next('/login')
        }
    }
});

// 暴露路由
export default router;